import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';

var genProStyle = function genProStyle(token) {
  var _token$componentCls;

  return _defineProperty({}, token.componentCls, (_token$componentCls = {
    marginBlockEnd: 16
  }, _defineProperty(_token$componentCls, "".concat(token.antCls, "-alert ").concat(token.antCls, "-alert-no-icon"), {
    paddingBlock: token.paddingSM,
    paddingInline: token.paddingLG
  }), _defineProperty(_token$componentCls, '&-info', {
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.3s',
    '&-content': {
      flex: 1
    },
    '&-option': {
      minWidth: 48,
      paddingInlineStart: 16
    }
  }), _token$componentCls));
};

export function useStyle(prefixCls) {
  return useAntdStyle('ProTableAlert', function (token) {
    var proToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    });

    return [genProStyle(proToken)];
  });
}